import React from 'react'
import { Github, Linkedin, Twitter } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer id="contact" className="footer-section text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/images/code-beacon-white.svg" 
                alt="Code Beacon" 
                width="160" 
                height="40" 
              />
            </div>
            <p className="mb-6 max-w-md" style={{ color: 'var(--text-muted)' }}>
              We design and protect intelligent software — secure, scalable, and powered by AI.
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="hover:text-accent-pink transition-colors" 
                style={{ color: 'var(--text-muted)' }}
              >
                <Github className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="hover:text-accent-pink transition-colors" 
                style={{ color: 'var(--text-muted)' }}
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="hover:text-accent-pink transition-colors" 
                style={{ color: 'var(--text-muted)' }}
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2" style={{ color: 'var(--text-muted)' }}>
              <li><a href="#" className="hover:text-accent transition-colors">Software Engineering</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">AI & Data Solutions</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Cybersecurity</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Cloud & Automation</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <ul className="space-y-2" style={{ color: 'var(--text-muted)' }}>
              <li><a href="#" className="hover:text-accent transition-colors">Get in Touch</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Insights</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Careers</a></li>
            </ul>
          </div>
        </div>
        
        <div 
          className="border-t mt-12 pt-8 text-center" 
          style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}
        >
          <p>&copy; 2024 Code Beacon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer